import React, { Component } from 'react';

import { renderTableHeader } from './tableHelper';

import formFields from '../../util/formFields';

import './tables.css';
import { switchTypes } from '../../util/constants';

export class UserList extends Component {
  state = {
    disable: true,
    selected: '',
    selectedService: '',
  };

  // Voice Settings business rules
  canAccessVoiceSettings(accountType, footprint) {
    const { switchTypeData } = this.props;

    // Disable access while loading or error
    if (switchTypeData.isLoading || switchTypeData.error) return false;

    if (
      accountType === 'COMMERCIAL' &&
      footprint === 'CHTR' &&
      [switchTypes.METASWITCH].includes(switchTypeData.switchType)
    )
      return false;
    return true;
  }

  isSpectrumVoice(accountType, footprint) {
    return accountType === 'RESIDENTIAL' && footprint === 'CHTR';
  }

  renderTableBody(data) {
    const { identities, accountGuid, accountType, footprint, hasVoiceLOB, hasSMPLOB } = data;

    if (!hasVoiceLOB && !hasSMPLOB) {
      return (
        <tr>
          <td>Please choose an account with voice or value added service access</td>
        </tr>
      );
    }

    // AKA Ghost accounts
    if (identities.length === 0) {
      return [
        {
          identityGuid: 'Not Available',
          username: 'Not Available',
          firstName: 'Not Available',
          lastName: 'Not Available',
          role: 'Not Available',
          vomSettings:
            hasVoiceLOB && this.canAccessVoiceSettings(accountType, footprint) ? (
              <input
                key={'unavailable'}
                tabIndex={0}
                id="option-1"
                className="check"
                name="user-list"
                type="radio"
                data-value={accountGuid}
                onClick={e => {
                  this.selectUser(e, 'VOM');
                }}
              />
            ) : (
              'Not Available'
            ),
          vasSettings: 'Not Available',
        },
      ].map((row, index) => {
        return (
          <tr key={index}>
            {formFields.userListTableHeaders[accountType].map(col => {
              return <td key={col.dataField}>{row[col.dataField]}</td>;
            })}
          </tr>
        );
      });
    } else {
      return identities.map((row, index) => {
        return (
          <tr key={index}>
            {formFields.userListTableHeaders[accountType].map(column => {
              if (column.dataField === 'vomSettings') {
                row[column.dataField] =
                  hasVoiceLOB && this.canAccessVoiceSettings(accountType, footprint) ? (
                    <input
                      key={index}
                      tabIndex={0}
                      id="option-1"
                      className="check"
                      name="user-list"
                      type="radio"
                      data-value={row.identityGuid}
                      onClick={e => {
                        this.selectUser(e, 'VOM');
                      }}
                    />
                  ) : (
                    'Not Available'
                  );
              }
              if (column.dataField === 'callGuard' && hasVoiceLOB) {
                row[column.dataField] = (
                  <input
                    key={index}
                    id="option-2"
                    className="check"
                    name="user-list"
                    type="radio"
                    data-value={row.identityGuid}
                    onClick={e => {
                      this.selectUser(e, 'VoiceMFE');
                    }}
                  />
                );
              }
              if (column.dataField === 'vasSettings' && hasSMPLOB) {
                // SMP only available to PRIMARY and ADMIN roles
                if (row.role === 'PRIMARY' || row.role === 'ADMIN') {
                  row[column.dataField] = (
                    <input
                      key={index}
                      tabIndex={0}
                      id="option-1"
                      className="check"
                      name="user-list"
                      type="radio"
                      data-value={row.identityGuid}
                      onClick={e => {
                        this.selectUser(e, 'VAS');
                      }}
                    />
                  );
                }
              }
              return <td key={column.text}>{row[column.dataField]}</td>;
            })}
          </tr>
        );
      });
    }
  }

  handleClick() {
    if (this.state.selected) {
      this.setState(({ disable }) => ({ disable: !disable }));
    }
  }

  selectUser(e, service) {
    let selectedUser = e.target;
    this.setState(() => ({
      selected: selectedUser.dataset.value,
      selectedService: service,
    }));
  }

  render() {
    const { accountData, initUser } = this.props;
    const { disable, selected } = this.state;
    const { userListTableHeaders: headerData } = formFields;

    const guid = accountData.identities.length === 0 ? { accountGuid: selected } : { identityGuid: selected };
    return (
      <div className="user-list-container">
        <h2 className="searchFormTitle">User List:</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>{renderTableHeader(headerData[accountData.accountType])}</tr>
            </thead>
            <tbody>{this.renderTableBody(accountData)}</tbody>
          </table>
        </div>
        <div className="consent-checkbox-container">
          <label>Consent to Browse on Behalf of? </label>
          <input
            disabled={!selected}
            type="checkbox"
            name="consentCheckbox"
            tabIndex={0}
            onChange={() => this.handleClick()}
          />
        </div>
        <br />
        <div className="continue-button-container">
          <button
            disabled={disable}
            type="submit"
            className="search-button"
            onClick={() => {
              initUser({
                ...guid,
                accountType: accountData.accountType,
                serviceType: this.state.selectedService,
                isVOM: this.isSpectrumVoice(accountData.accountType, accountData.footprint),
                footprint: accountData.footprint,
                division_id: accountData.divisionBillingId,
                account_number: accountData.accountNumber,
                switchType: this.props.switchTypeData.switchType,
              });
            }}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }
}

export default UserList;
